import { RowDataKPI } from "../../components/StaffPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the KPITable factory
 */
class KPIRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/kpi/read-by-uid"
        this.accessData = "kpis"
    }

    create(kpi: any): RowDataKPI {
        const rowDataKpi: RowDataKPI = {
            kpiObjectiveID: kpi.kpi_objective_id,
            title: kpi.title,
            timePeriodID: kpi.time_period_id,
            timePeriod: kpi.type,
            duration: kpi.duration,
            score: kpi.score,
            target: kpi.target,
        };
        return rowDataKpi;
    }

    generateParams(params: any, extra: any): any {
        params["uid"] = extra.uid
        params["current"] = extra.current
        return params
    }
}

let kpiRow: KPIRow | null = null;

export default function getKPIRow(): KPIRow {
    if (kpiRow === null)
        kpiRow = new KPIRow()
    return kpiRow
}